(function($, FUNCTIONS, cssua){
	const clickEvent = cssua.ua.desktop ? 'click' : 'tap';
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const slideSpeed = '400';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		slides(){
			if($('.products-slide01').length) {
				$('.products-slide01').slick({
					arrows: false,
					autoplay: false,
					slidesToShow: 4,
					loop: false,
					infinite: true,
					dots: false,
					speed: 200,
					responsive: [
						{
						breakpoint: 768,
							settings: {
							arrows: true,
							autoplay: false,
							slidesToShow: 1,
							slidesToScroll: 1,
							centerMode: true,
							loop: true,
							infinite: true,
							dots: true,
							centerPadding: '10%'
						  }
						}
					]
				});
			}
			if($('.products-slide02').length) {
				$('.products-slide02').slick({
					arrows: true,
					autoplay: false,
					slidesToShow: 4,
					slidesToScroll: 4,
					loop: true,
					infinite: true,
					dots: true,
					speed: 200,
					responsive: [
						{
						breakpoint: 768,
							settings: {
							arrows: true,
							autoplay: false,
							slidesToShow: 1,
							slidesToScroll: 1,
							centerMode: true,
							loop: true,
							infinite: true,
							dots: true,
							centerPadding: '10%'
						}
						}
					]
				});
			}
			if($('.products-slide03').length) {
				$('.products-slide03').slick({
					arrows: true,
					autoplay: false,
					slidesToShow: 4,
					slidesToScroll: 4,
					loop: true,
					infinite: true,
					dots: true,
					speed: 200,
					responsive: [
						{
						breakpoint: 768,
							settings: {
							arrows: true,
							autoplay: false,
							slidesToShow: 1,
							slidesToScroll: 1,
							centerMode: true,
							loop: true,
							infinite: true,
							dots: true,
							centerPadding: '10%'
						}
						}
					]
				});
			}
		},
		modal() {
			var scrollTopNow;

			$('.js-products-modal-btn').on('click', function(event){
				var title = $(this).data('title');
				var imgs = $(this).data('imgs');
				var lead = $(this).data('lead');
				var link = $(this).data('link');

				$('.products-modal-overlay').addClass(a);
				$('.products-modal-content').html(
					'<ul class="pure-g products-item">' +
						'<li class="pure-u-1-4 pure-u-md-1-1 products-item-left">' +
							'<h3 class="products-item-title ff_mincho">'+ title +'</h3>' +
							'<img src="/mens/rn-images/products/modal/'+ imgs +'_logo_pc.jpg" class="width-u-100" data-view="pc tablet">' +
							'<img src="/mens/rn-images/products/modal/'+ imgs +'_logo_sp.jpg" class="width-u-100" data-view="sp">' +
						'</li>' +
						'<li class="pure-u-3-4 pure-u-md-1-1 products-item-right">' +
							'<div class="products-item-icon">' +
								'<img src="/mens/rn-images/products/modal/'+ imgs +'_icons_pc.jpg" class="width-u-100" data-view="pc tablet">' +
								'<img src="/mens/rn-images/products/modal/'+ imgs +'_icons_sp.jpg" class="width-u-100" data-view="sp">' +
							'</div>' +
							'<ul class="pure-g">' +
								'<li class="pure-u-2-3 pure-u-md-1-1">' +
									'<p class="fs_middle_s">'+ lead +'</p>' +
								'</li>' +
								'<li class="pure-u-1-3 pure-u-md-1-1">' +
									'<div class="products-item-links">' +
										'<a href="'+ link +'" class="products-item-links-btn">» もっと詳しく見る</a>' +
									'</div>' +
								'</li>' +
							'</ul>' +
						'</li>' +
					'</ul>'
				);

				scrollTopNow = $(window).scrollTop();

				$('body').addClass(f);
				$( '.container' ).css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				event.preventDefault();
			});

			$('.products-modal-closeBtn').on('click', function(event){
				$('.products-modal-content').html('');
				$('.products-modal-overlay').removeClass(a);
				$('body').removeClass(f);
				$( '.container' ).css( {
					position: 'static',
				} );
				$(window).scrollTop(scrollTopNow);
				event.preventDefault();
			});

			$('.products-modal-back').on('click', function(event){
				$('.products-modal-content').html('');
				$('.products-modal-overlay').removeClass(a);
				$('body').removeClass(f);
				$( '.container' ).css( {
					position: 'static',
				} );
				$(window).scrollTop(scrollTopNow);
				event.preventDefault();
			});
		},
		change() {
			if(FUNCTIONS.va.window.width < 980) {
				var flag = false;
				$('.js-imgChange').on('click', function(event){
					if(!flag) {
						$(this).addClass(a);
						flag = true;
					}else {
						$(this).removeClass(a);
						flag = false;
					}
				});
			}
			if($('.js-products-tabchange').length) {
				setTimeout(function(){
					$('.start-chart-box01-head01Wrap').matchHeight();
					$('.js-start-chart-box01-tagWrap').matchHeight();
					$('.start-chart-box01-head02').matchHeight();
					$('.js-start-chart-box01-list').matchHeight();
					
				}, 1000);
				// クリックされたときの動作
				$('.js-products-tabchange').on('click', function () {
					$(this).parents('.js-products-tabchangeWrap').find('.js-products-tabchange-li').removeClass(a);
					$(this).parents('.js-products-tabchange-li').addClass(a);
					const index = $(this).parents('.js-products-tabchangeWrap').find('.js-products-tabchange').index(this);
					$(this).parents('.js-products-tabchangeWrap').find('.js-products-tabchange-contents').removeClass(a).eq(index).addClass(a);
					setTimeout(function(){
						$('.start-chart-box01-head01Wrap').matchHeight();
						$('.js-start-chart-box01-tagWrap').matchHeight();
						$('.start-chart-box01-head02').matchHeight();
						$('.start-chart-box01-list').matchHeight();
						
					}, 500);
				})
			}
		},
		loadDelayScript(){
			var _this = this;
			_this.slides();
			_this.modal();
			_this.change();
		}
	};

	$(() => FUNCTIONS.loadDelayScript());
})(window.jQuery, window.FUNCTIONS, window.cssua);
$(window).on('load', function(){
	if($('.js-products-tabchange').length) {
		setTimeout(function(){
			$('.start-chart-box01-head01Wrap').matchHeight();
			$('.js-start-chart-box01-tagWrap').matchHeight();
			$('.start-chart-box01-head02').matchHeight();
			$('.start-chart-box01-list').matchHeight();
			$('.start-chart-box01-label').matchHeight();
		}, 1500);
	}
});